/**
 * @fileoverview PATCH handler for the "/engagement/approvals/:context_id/approve_all" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementApprovalsContextIdApproveAllCacheKeys } from "./constants";
import type {
  PatchEngagementApprovalsContextIdApproveAllProps,
  EngagementApprovalsContextIdApproveAllResult,
} from "./types";

export const patchEngagementApprovalsContextIdApproveAll = reactQueryMutationAdapter(
  engagementApprovalsContextIdApproveAllCacheKeys,
  (
    props: PatchEngagementApprovalsContextIdApproveAllProps
  ): Promise<EngagementApprovalsContextIdApproveAllResult> => {
    return fetch(`/engagement/approvals/${props.contextId}/approve_all`, "PATCH", {
      context_id: props.contextId,
      context_type: props.contextType,
      is_messaging_rule_approval_only: props.isMessagingRuleApprovalOnly,
    });
  }
);
